import { render, staticRenderFns } from "./History.vue?vue&type=template&id=523b53ce"
import script from "./History.vue?vue&type=script&setup=true&lang=ts"
export * from "./History.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./History.vue?vue&type=style&index=0&id=523b53ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports